import {Trans} from '@lingui/macro';
import React from 'react';

import {CollapsedItemKeyPrefixesEnum} from '../../../models/api/localPreferencesModel';
import {useSettingsInfoBox, UseSettingsInfoBoxProps} from '../../helpers/settingsInfoBox';

/*
 * Consts.
 */

// @TODO: Write body of info box.
const serversInfoBoxProps: UseSettingsInfoBoxProps = {
  settingsExpandedKey: CollapsedItemKeyPrefixesEnum.SETTINGS_SERVERS,
  title: <Trans id="settings-servers-infobox-title">Servers</Trans>,
  body: (
    <Trans id="settings-servers-infobox-body">
      <p>Write something meaningful here.</p>
    </Trans>
  ),
};

/*
 * Hook.
 */

export function useServersInfoBox() {
  return useSettingsInfoBox(serversInfoBoxProps);
}
